import formCheckbox from '@/components/forms/checkbox/checkbox.vue';

export default {
  props: {
    validation: {
      type: Object,
      required: true,
    },
  },
  components: {
    formCheckbox,
  },
  computed: {
    hasOneUpperLower() {
      return this.validation.hasOneLower && this.validation.hasOneUpper;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/password-requirements/password-requirements.js